import React from 'react';
import classNames from 'classnames';

import css from './PageContainer.module.css';

/**
 * The content area of a wide page (Favorites, Cart, Offers, Your listings, Inbox...):
 * up to 1440px wide, centred, with the same side and top spacing on every page.
 */
const PageContainer = ({ as: Tag = 'div', className, rootClassName, children }) => (
  <Tag className={classNames(rootClassName || css.root, className)}>{children}</Tag>
);

export default PageContainer;
